import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  productItem_container: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
    margin: "10px 0px",
    ...(theme.direction === "rtl" ? { paddingLeft: 5 } : { paddingRight: 5 }),
    cursor: "pointer",
  },
  leftSide: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "81px",
    minWidth: 81,
    height: "112px",
    backgroundColor: "transparent",
    fontSize: "14px",
    color: "red",
    ...(theme.direction === "rtl" ? { marginLeft: 5 } : { marginRight: 5 }),
  },
  rightSide: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
  },
  productTitle: {
    letterSpacing: 0,
    fontSize: "16px",
    fontWeight: "bold",
  },
  productDescription: {
    fontSize: "14px",
    margin: "0",
  },
  productImage: {
    width: "100%",
  },
}));

export default useStyles;
